// 首页信任数字带：目的港数=港口字典实时数量（拉取失败显示 -，不写死）；
// 履约节点数为真实常量（运行库节点链 17 节点全链贯通，节点增减属架构级变更，属可维护口径）；
// 在售品类/商品数来自接口实时聚合
import { Box, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { usePrefs } from '@/store/BuyerPrefsContext';
import { productApi } from '@/api/productApi';

/** 履约主链节点数（运行库节点链 17 节点全链贯通：order→produce→…→deliver） */
const FULFILLMENT_NODE_COUNT = 17;

interface TrustBandProps {
  /** 在售 SPU 总数（接口 total） */
  spuTotal: number;
  /** 在售品类数（SPU 列表聚合） */
  categoryCount: number;
}

export default function TrustBand({ spuTotal, categoryCount }: TrustBandProps) {
  const { t } = usePrefs();
  /** 目的港数：港口字典实时数量（公开端点 + 模块级缓存）；拉取失败显示 '-'，不写死兜底数字 */
  const [portCount, setPortCount] = useState<number | null>(null);
  useEffect(() => {
    let alive = true;
    productApi.listPublicPortOptionsCached()
      .then((list) => { if (alive && Array.isArray(list)) setPortCount(list.length); })
      .catch(() => { /* 显示 '-' */ });
    return () => { alive = false; };
  }, []);
  const items = [
    { value: portCount != null ? String(portCount) : '-', label: t('trust.ports') },
    { value: String(FULFILLMENT_NODE_COUNT), label: t('trust.nodes') },
    { value: String(categoryCount || spuTotal), label: t('trust.cats') },
    { value: '1v1', label: t('trust.advisor') },
  ];

  return (
    <Box className="buyer-trust" sx={{ display: 'grid', gridTemplateColumns: { xs: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)' } }}>
      {items.map((it) => (
        <Box key={it.label} sx={{ textAlign: 'center' }}>
          <Typography sx={{ fontSize: { xs: '20px', md: '24px' }, fontWeight: 700, color: '#059669', lineHeight: 1.2 }}>
            {it.value}
          </Typography>
          <Typography sx={{ fontSize: '11px', color: '#065F46', mt: 0.25 }}>{it.label}</Typography>
        </Box>
      ))}
    </Box>
  );
}
